import { FC } from "react";
import styles from "./DrawDate.module.scss";

interface IDrawDateProps {
    drawDate: string;
    timeSubText: string;
}

export const DrawDate: FC<IDrawDateProps> = ({ drawDate, timeSubText }) => (
    <div className={styles.row}>
        <div className={styles.prizeTime}>
            <span className={styles.label}>Дата розыгрыша</span>
            <span className={styles.date}>{drawDate}</span>
            <span className={styles.subtext}>{timeSubText }</span>
        </div>
    </div>
);